<script>
    export let name;
    export let size = 16;

    const paths = {
        check: ["M20 6 9 17l-5-5"],
        x: ["M18 6 6 18", "M6 6l12 12"],
        send: ["m22 2-7 20-4-9-9-4Z", "M22 2 11 13"],
        download: ["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", "m7 10 5 5 5-5", "M12 15V3"],
        layers: ["m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z", "m6.08 10.37-3.49 1.59a1 1 0 0 0 0 1.83l8.59 3.91a2 2 0 0 0 1.65 0l8.59-3.9a1 1 0 0 0 0-1.83l-3.5-1.6"],
        refresh: ["M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", "M21 3v5h-5", "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", "M8 16H3v5"],
        chevronDown: ["m6 9 6 6 6-6"],
        chevronRight: ["m9 18 6-6-6-6"],
        logout: ["M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", "m16 17 5-5-5-5", "M21 12H9"],
        more: [],
        external: ["M15 3h6v6", "M10 14 21 3", "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"],
    };
</script>

<svg class="icon" width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    {#if name === 'more'}
        <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/>
        <circle cx="19" cy="12" r="1.4" fill="currentColor" stroke="none"/>
        <circle cx="5" cy="12" r="1.4" fill="currentColor" stroke="none"/>
    {:else}
        {#each paths[name] as d}
            <path {d}/>
        {/each}
    {/if}
</svg>
